import { helper } from './base'

const basketVariant = {
  'p > span:nth-of-type(2)': {
    borderRadius: 8,
    bg: 'brand.teal5',
  },
}

const insufficientFunds = {
  color: 'brand.red',
}

export const PriceBreakdownTotalDue = helper.defineMultiStyleConfig({
  baseStyle: helper.definePartsStyle({
    heading: {
      '&[data-value="basketTotal"]': {
        fontSize: { base: 'lg', md: '2xl' },
      },
      fontSize: { base: 'lg', md: '4xl' },
    },
    priceTotalSummaryWrapper: {
      'p > span:nth-of-type(2)': {
        borderRadius: 8,
        bg: 'brand.teal10',
      },
    },
    currencyPair: {
      span: {
        _first: {
          fontSize: 'sm',
        },
        _last: {
          fontSize: '2xl',
          fontWeight: 'medium',
        },
      },
      _invalid: {
        ...insufficientFunds,
      },
    },
    priceTotalWrapper: {
      '&[data-value="basketTotal"]': {
        ...basketVariant,
      },
    },
  }),
  variants: {},
})
